import React, { useState } from "react";
import { useNavigate } from "react-router";
import { enqueueSnackbar } from "notistack";

import theme from "@/constants/theme";
import { routes } from "@/constants/routes";
import useLearningRoutes from "@/context/routes/hook";
import { routesService } from "@/services/routes";
import Button from "@/components/input/Button";
import Dialog from "@/components/dataDisplay/Dialog";

interface DeleteButtonProps {
  routeId: string;
  loading: boolean;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ routeId, loading }) => {
  const [open, setOpen] = useState(false);
  const { deleteRoute } = useLearningRoutes();
  const navigate = useNavigate();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleDelete: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    const service = routesService.deleteRoute;
    service(routeId)
      .then(() => {
        deleteRoute(routeId);
        navigate(routes.admin.routes.root);
        enqueueSnackbar("Ruta eliminada correctamente", {
          variant: "success",
        });
      })
      .catch((error) => {
        console.error("Error deleting route", error);
        enqueueSnackbar("Error al eliminar la ruta", {
          variant: "error",
        });
      });
  };

  return (
    <>
      <Button
        type="button"
        variant="danger"
        onClick={handleOpen}
        disabled={loading}
      >
        Eliminar Ruta
      </Button>
      <Dialog open={open} setOpen={setOpen}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            padding: 8,
          }}
        >
          <h3
            style={{
              color: theme.colors.text.title,
            }}
          >
            ¿Estás seguro de que deseas eliminar esta ruta?
          </h3>
          <p>
            Es posible que todos sus contenidos o los progresos de los
            usuariosse se eliminen también.
          </p>
          <p>{routeId}</p>
          <div style={{ display: "flex", gap: 8, justifyContent: "end" }}>
            <Button type="button" variant="ghost" onClick={handleCancel}>
              Cancelar
            </Button>
            <Button type="button" variant="danger" onClick={handleDelete}>
              Eliminar
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DeleteButton;
